<template>
  <div
    class="sms-right d-flex flex-column"
    :class="isMobile ? 'sms-xs-right' : ''"
  >
    <div class="sms-right-header">
      <v-list-item v-if="chat.id" :dense="isMobile">
        <v-list-item-icon class="mr-2" v-if="isMobile">
          <v-btn icon @click="$router.back()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium text-capitalize">
            <!-- {{ chat.name }} -->
            <input type="text" @keyup.enter="toggleNameField" v-model="chat.name" :disabled="!isEditable"
              ref="nameInput">
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ formatPhone(chat.phone) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-btn icon @click="toggleNameField()">
          <v-icon v-if="isEditable">
            mdi-check
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
    </div>
    <div
      class="sms-right-content pa-4 d-flex flex-column-reverse"
      ref="messages"
      @scroll="onScroll"
      id="message-container"
    >
      <v-card
        outlined
        v-for="(item, i) in sortedMessages"
        :key="i"
        :id="`${item.key}`"
        max-width="80%"
        :color="color(item)"
        :class="align(item)"
        :dark="item.type == 'u'"
        class="mb-5 chat_container"
      >
        <v-btn
          icon
          x-small
          class="chat_delete__btn black--text"
          style="right: 30px"
          @click="copy(item)"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn
          icon
          v-if="isAdmin"
          x-small
          class="chat_delete__btn"
          color="red"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <template v-if="item.img">
          <v-card-text class="pb-0" v-for="(img, j) in getImages(item)" :key="j">
            <ImageView :img="img"></ImageView>
          </v-card-text>
        </template>
        <v-card-text
          :style="textColor(item)"
          v-if="item.text"
          v-html="format(item)"
          class="pb-0 pt-5"
        >
        </v-card-text>
        <v-card-actions>
          <v-chip small v-if="isAdminStatus(item)" :color="smsColor(item)" outlined class="ml-2 mr-2">{{ smsStatus(item)
            }}</v-chip>
          <v-spacer></v-spacer>
          <div class="caption pr-2 grey--text">
            {{ formatDate(item.ts) }}
          </div>
        </v-card-actions>
      </v-card>
      <div class="d-flex justify-center mb-3" v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <div class="sms-right-footer pa-4" v-if="chat.id">
      <div class="chat__media mb-4" v-if="media">
        <v-btn icon color="red" @click="media = null">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <img :src="media" />
      </div>
      <v-textarea
        v-model.trim="message"
        label="Type a message"
        type="text"
        class="chat__input"
        clearable
        no-details
        outlined
        auto-grow
        rows="1"
        ref="message"
        dense
        row-height="15"
        append-outer-icon="mdi-send"
        @click:append-outer="send"
        hide-details
      >
        <template v-slot:prepend>
          <v-btn
            icon
            class="mt-0"
            @click="$refs.input.click()"
            :color="media ? 'green' : ''"
          >
            <v-icon> mdi-image </v-icon>
          </v-btn>
          <sms-template-list @onSelect="setChat"></sms-template-list>
          <input
            type="file"
            @change="onFileChange"
            accept="image/*"
            ref="input"
          />
        </template>
      </v-textarea>
    </div>
  </div>
</template>
<script>
import { rooms, functions, chat_list } from "../../assets/js/firebase";
import SMSColor from "../../assets/js/sms_color";
import SMSStatus from "../../assets/js/sms_status";
import { getDate, resizeFile } from "../../assets/js/common";
import ImageView from "./Image.vue";
import moment from "moment";
import SmsTemplateList from "../smsTemplates/SmsTemplateList.vue";
export default {
  props: {
    chat: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { ImageView, SmsTemplateList },
  data() {
    return {
      message: "",
      messages: [],
      textComplete: null,
      media: "",
      lastScrollPosition: 0,
      lastItem: null,
      scrollHeight: 0,
      ref: null,
      loading: false,
      isCompleted: false,
      isEditable: false,
      selectedTemplate:null
    };
  },

  watch: {
    chat() {
      this.listen();
      this.initSmsTemplate();
    },
  },
  computed: {
    sortedMessages() {
      return [...this.messages].sort((a, b) => new Date(b.ts) - new Date(a.ts));
    },
    isMobile() {
      return ["smsView", "technicianSMSView"].indexOf(this.$route.name) != -1;
    },
    isCustomer() {
      let { name } = this.$route;
      return name === "sms" || name == "smsView";
    },
    templates() {
      return this.$store.getters.smsTemplates;
    },
  },
  beforeDestroy() {
    const vm = this;
    if (vm.textComplete) vm.textComplete.destroy();
    if (vm.ref !== null) vm.ref.off();
  },
  methods: {
    onScroll() {
      const container = document.getElementById("message-container"); // Replace 'scroll-container' with your container element ID
      if (container && !this.loading) {
        if (this.isCompleted) {
          console.log("All chats fetched successfully");
          return;
        }
        const scrollHeight = container.scrollHeight - this.scrollHeight;
        let offset = scrollHeight + container.scrollTop;
        if (offset < 10) {
          console.log("Scrolled to top....");
          this.fetchChatMessages();
        }
      }
    },
    copy({ text }) {
      navigator.clipboard.writeText(text);
    },
    setChat(text) {
      this.message = text;
      console.log(text);
    },
    formatDate(ts) {
      return moment
        .tz(ts, "America/Los_Angeles")
        .local()
        .format("MM/DD/YYYY hh:mm A");
    },
    remove(item) {
      const vm = this;
      let { chat } = vm;
      vm.$confirm.show({
        message: "Are you sure, Do you want to remove this message?",
        onConfirm: async () => {
          try {
            vm.$loader.show();
            let { data } = await functions.httpsCallable("removeMessage")({
              key: item.key,
              chat: chat.id,
            });
            const findMessageIndex = vm.messages.findIndex((i) => i.key == item.key);
            if(findMessageIndex !== -1){
              vm.messages.splice(findMessageIndex, 1);
            }
            vm.$loader.hide();
            if (!data.status) {
              vm.$alert.show(data.message);
            }
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        },
      });
    },
    async onFileChange() {
      const vm = this;
      vm.media = null;
      let files = vm.$refs.input.files;
      if (files[0]) {
        vm.media = await resizeFile(files[0]);
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getImages({ img }) {
      let list = [];
      if (typeof img === "string") {
        list.push(img);
      }
      if (img instanceof Array == true) {
        list = img;
      }
      return list;
    },
    
    // /// Keep for backup
//     formatPhone(phone) {
//   if (!phone) return null;

//   const cleaned = String(phone).replace(/\D/g, "");

//   // Case 1: Legacy 10-digit US number
//   if (cleaned.length === 10) {
//     return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
//   }

//   // Case 2: 11 or 12 digits (with country code)
//   if (cleaned.length > 10 && cleaned.length <= 12) {
//     const local = cleaned.slice(-10); // last 10 digits
//     const country = cleaned.slice(0, cleaned.length - 10); // prefix
//     return `+${country} (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
//   }

//   // Invalid / unexpected case
//   return phone;
// }

    formatPhone(phone) {
      if (!phone) return null;

  // Remove all non-digits
  const cleaned = ("" + phone).replace(/\D/g, "");

  // If number is exactly 10 digits → format as US number
  if (/^\d{10}$/.test(cleaned)) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  // If number has country code (11–14 digits) → keep country code + format last 10
  if (cleaned.length > 10 && cleaned.length <= 14) {
    const country = cleaned.slice(0, cleaned.length - 10);
    const local = cleaned.slice(-10);
    return `${country} (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  }

  // If not matching → just return raw digits
  return `${cleaned}`;
    },
    color({ type }) {
      return type === "u" ? "yellow lighten-4" : "";
    },
    textColor({ type }) {
      return type === "u" ? { color: "black!important" } : {};
    },
    smsStatus({ status }) {
      return SMSStatus[status];
    },
    smsColor({ status }) {
      return SMSColor[status];
    },
    fetchChatMessages() {
      const vm = this;
      return new Promise((resolve, reject) => {
        if (vm.loading) {
          resolve();
          return;
        }
        vm.loading = true;
        let query = rooms
          .child(vm.chat.id)
          .child("messages")
          .orderByChild("ts");
        if (vm.lastItem) {
          query = query.endAt(vm.lastItem);
        }
        query
          .limitToLast(20)
          .once("value")
          .then((snapshot) => {
            if(snapshot?.val())
              if (Object.keys(snapshot.val()).length < 20) {
                vm.isCompleted = true;
              }
            let messages = [];
            snapshot.forEach((doc) => {
              let item = { ...doc.val(), key: doc.key };
              let message = vm.messages.find((i) => i.key == doc.key);
              if (message == null) {
                messages.push(item);
                vm.messages.push(item); // Use unshift to insert items at the beginning of the array
              }
            });
            setTimeout(() => {
              vm.loading = false;
            }, 100);
            if (vm.messages.length > 0) {
              vm.lastItem = messages[0].ts;
              console.log("last item", vm.lastItem);
            }
            resolve();
          })
          .catch((error) => {
            vm.loading = false;
            reject(error);
          });
      });
    },
    async listen() {
      try {
        const vm = this;
        vm.lastItem = null;
        vm.loading = false;
        vm.lastScrollPosition = null;
        vm.isCompleted = false;
        vm.messages = [];
        let { chat } = vm;
        if (vm.ref !== null) vm.ref.off();
        if (chat.id) {
          await this.fetchChatMessages();
          setTimeout(() => {
            vm.$refs.messages.scrollTop = Math.floor(
              vm.$refs.messages.offsetHeight + 10000000
            );
          }, 100);

          vm.ref = rooms
            .child(chat.id)
            .child("messages")
            .orderByChild("ts")
            .limitToLast(1);
          vm.ref.on("value", (snap) => {
            snap.forEach((doc) => {
              let data = doc.val();
              data.key = doc.key;
              const existingMessageIndex = vm.messages.findIndex((i) => i.key == doc.key);
              if (existingMessageIndex === -1) {
                console.log("new message", data);
                vm.messages.push(data);
                setTimeout(() => {
                  vm.$refs.messages.scrollTop = Math.floor(
                    vm.$refs.messages.offsetHeight + 10000000
                  );
                }, 100);
              }else{
                this.$set(vm.messages, existingMessageIndex, data);
              }
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    align({ type }) {
      return type == "u" ? "align-self-start" : "align-self-end";
    },
    isAdminStatus({ type, status }) {
      return type == "a" && status !== undefined;
    },
    date() {
      return getDate();
    },
    format({ text }) {
      if (text) return text.split("\n").join("<br/>");
    },
    async send() {
      const vm = this;
      let { message, chat, media, isCustomer } = vm;
      let updated_at = vm.date();
      if (message === "" && media == null) return;
      try {
        vm.$root.loader = true;
        let doc = {
          text: message,
          updated_at,
          phone: chat.id,
          ...(vm.selectedTemplate?.media) && {
            media: vm.selectedTemplate?.media || null
          }
        };
        if (vm.media) {
          doc.media = vm.media;
        }
        let way = isCustomer ? "sendSMS" : "sendTechnicianSMS";
        let { data } = await functions.httpsCallable(way)(doc);
        if (!data.status) {
          vm.$root.alert(data.message);
        } else {
          vm.message = "";
        }
        vm.media = null;
        vm.selectedTemplate = null;
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
      }
    },
    initSmsTemplate() {
      const vm = this;
      if (vm.textComplete) vm.textComplete.destroy();
      vm.$nextTick(() => {
        if (vm.$refs.message) {
          let ele = vm.$refs.message.$el.querySelector("textarea");
          const { Textcomplete } = require("@textcomplete/core");
          const { TextareaEditor } = require("@textcomplete/textarea");
          const editor = new TextareaEditor(ele);

          vm.textComplete = new Textcomplete(
            editor,
            [
              {
                // eslint-disable-next-line no-useless-escape
                match: /(^|\b)(\w{1,})$/,
                index: 0,
                search: async (term, callback) => {
                  const templateSelected = vm.templates.filter((i) =>
                    i._id.toString().startsWith(term)
                  )
                  if (templateSelected?.length)
                    vm.selectedTemplate = templateSelected[0];
                  callback(templateSelected);
                },
                template: (item) => `<b>${item._id}</b>: ${item.title || "-"}`,
                replace: (result) => `${result.text || ""}`,
                cache: false,
              },
            ],
            {
              dropdown: {
                placement: "top",
              },
            }
          );
        }
      });
    },
    async toggleNameField() {
      const vm = this
      const ref = vm.$refs.nameInput
      if(!vm.isEditable) {
        ref.style.outline = "none"
        ref.style.borderBottom = "1px solid #777"
        vm.isEditable = !vm.isEditable
        setTimeout(() => {
          ref.focus()
        }, 100)
      } else {
        vm.$confirm.show({
        message: "Are you sure you want to edit the name?",
          onConfirm: async () => {
            try {
              vm.$loader.show();
              await chat_list.doc(vm.chat.id).update({ name: ref.value });
              const newQuery = {
                ...vm.$route.query || {},
                name: ref.value,
              }
              const searchParams = new URLSearchParams(newQuery);
              vm.$router.replace(`${vm.$route.path}?${searchParams.toString()}`);
              vm.$loader.hide();
              vm.isEditable = !vm.isEditable
              ref.style.borderBottom = "none"
              vm.$store.dispatch('triggerRerender', { name: ref.value, id: vm.chat.id })
            } catch (error) {
              vm.$loader.hide();
              vm.$alert.show(error.message);
            }
          }
        });
      }
    },
  },
  async mounted() {
    this.scrollHeight =
      document.getElementById("message-container").scrollHeight;
    console.log("scroll height", this.scrollHeight);
    this.listen();
    this.initSmsTemplate();
  },
};
</script>
<style lang="scss">
.sms {
  &-right {
    .chat_container {
      display: relative;
      .chat_delete__btn {
        position: absolute;
        right: 5px;
        top: 5px;
      }
    }
    .chat__input {
      .v-input__prepend-outer {
        margin-top: 2px !important;
        input {
          display: none;
        }
      }
    }
    .chat__media {
      width: 135px;
      height: 135px;
      position: relative;
      button {
        position: absolute;
        right: 0px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &-header {
      background: white;
    }
    .message-image {
      max-height: 400px;
      object-fit: contain;
      max-width: 500px;
    }
    &-footer {
      background: white;
    }
    width: calc(100% - 350px);
    height: calc(100vh - 67px);
    &-content {
      width: 100%;
      overflow-y: auto;
      border-bottom: 1px solid lightgray;
      flex: 1;
    }
  }
}
.sms-xs-right {
  width: 100% !important;
}
</style>
